import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Printer } from "lucide-react";

// Phase 3M — extracted verbatim from RetailCustomer.jsx::OrderConfirmedModal.
// Behaviour, layout, and testids identical.
export default function OrderConfirmedModal({ tenant, order, slug, onPrint, onNewOrder }) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center px-4 py-8 bg-black/70" data-testid="retail-order-confirmed">
      <div className="w-full max-w-md bg-white rounded-2xl border-t-4 border-emerald-500 p-6 text-center text-stone-900 shadow-2xl">
        <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
        <h2 className="font-serif text-3xl mt-3">Order Confirmed</h2>
        <p className="text-sm text-stone-500 mt-1">Thank you, {tenant?.name || "the team"} has received your order.</p>
        <div className="mt-5 bg-stone-50 rounded-xl border border-stone-200 p-5">
          <div className="text-[10px] uppercase tracking-widest text-stone-500">Order number</div>
          <div className="font-mono text-3xl tracking-wider text-stone-900 mt-1" data-testid="retail-order-code">
            {order.order_code}
          </div>
        </div>
        <p className="mt-4 text-sm text-stone-600">
          Please proceed to the counter — your order will be ready shortly.
        </p>
        <div className="mt-6 grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onPrint}
            data-testid="retail-print-receipt-btn"
            className="h-11 rounded-md border border-stone-300 text-sm font-medium text-stone-700 hover:bg-stone-50 inline-flex items-center justify-center gap-1.5"
          >
            <Printer className="w-4 h-4"/> Print Receipt
          </button>
          <button
            type="button"
            onClick={onNewOrder}
            data-testid="retail-start-new-order-btn"
            className="h-11 rounded-md bg-orange-500 text-white text-sm font-semibold hover:bg-orange-600"
          >
            Start New Order
          </button>
        </div>
        <Link
          to={`/retail/${slug}/orders/${order.order_code}`}
          className="block mt-3 text-xs text-stone-500 underline-offset-2 hover:underline"
          data-testid="retail-order-status-link"
        >
          View live order status →
        </Link>
      </div>
    </div>
  );
}
